// extracted by mini-css-extract-plugin
export default {"button":"button-a5a2f8b4"};